import { render, staticRenderFns } from "./mob-basic.vue?vue&type=template&id=fdfe9720"
import script from "./mob-basic.vue?vue&type=script&setup=true&lang=js"
export * from "./mob-basic.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports